import React from 'react';
import { IconProps } from '../../../../assets/icons/types';

const CartIcon = ({ className, color }: IconProps) => {
  return (
    <svg
      className={className}
      width="18"
      height="20"
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2679 4.99048H2.45454C1.65122 4.99048 1 5.64171 1 6.44503V17.5456C1 18.3489 1.65122 19.0001 2.45454 19.0001H15.2679C16.0713 19.0001 16.7225 18.3489 16.7225 17.5456V6.44503C16.7225 5.64171 16.0713 4.99048 15.2679 4.99048Z"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.875 4.99046C4.875 2.78949 6.66447 1 8.86543 1C11.0664 1 12.8559 2.78949 12.8559 4.99046"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8559 7.34448C12.8559 9.54545 11.0664 11.3349 8.86543 11.3349C6.66447 11.3349 4.875 9.54545 4.875 7.34448"
        stroke={color ?? 'current-color'}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CartIcon;
